import LocalStorageKeys from '@/constants/LocalStorageKeys'

export default {
  getGoogleApiKey() {
    const testingApiKey = process.env.VUE_APP_E360_GOOGLE_API_KEY
    const e360ApiKey = localStorage.getItem(LocalStorageKeys.GOOGLE_API_KEY)
    return e360ApiKey || testingApiKey
  },
  getLanguage() {
    const userLocaleParts = this.getLocale().split('-')
    return userLocaleParts[0]
  },
  getRegion() {
    const userLocaleParts = this.getLocale().split('-')
    return userLocaleParts[1]
  },
  getLocale() {
    const testingLocale = process.env.VUE_APP_E360_LOCALE
    const e360Locale = localStorage.getItem(LocalStorageKeys.E360_LOCALE)
    const userLocale = e360Locale || testingLocale
    if (userLocale) {
      return userLocale
    }
    return 'en-AU'
  },
}
